import { TReportType } from "../../types/reporting.types";

/** Report pages and their previews are routed under a URL containing one of these keys. */
const REPORT_TYPE_BY_URL_KEY: Record<string, TReportType> = {
	audit: "audit",
	incident: "incident_report",
	"lessons-learned": "lesson_learned",
	moc: "moc",
	ofi: "ofi",
	"non-conformance": "non_conformance",
};

export const reportTypeFromPath = (
	pathname: string
): TReportType | undefined => {
	const urlKey = Object.keys(REPORT_TYPE_BY_URL_KEY).find((key) =>
		pathname.includes(key)
	);
	return urlKey ? REPORT_TYPE_BY_URL_KEY[urlKey] : undefined;
};
